import { PronosticoMeteorologicoApi } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { checkWebp } from '@/components/helpers/checkWebp'
import { client as fetch } from './ClientService'

export interface PronosticoMeteorologicoInterface {
  getPronosticoMeteorologico():Promise<Commit<PronosticoMeteorologicoApi>>
}

export default class PronosticoMeteorologicoService implements PronosticoMeteorologicoInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  hash: string = this.env.settings.PELIGRO.hash || ''
  webp: string = '&webp=0'

  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async getPronosticoMeteorologico (): Promise<Commit<PronosticoMeteorologicoApi>> {
    try {
      const { isWebpSupported } = await checkWebp('lossy')
      this.webp = isWebpSupported && this.env.settings.PRONOSTICO_METEOROLOGICO.useWebp ? '&webp=1' : '&webp=0'
      const response = await fetch(`${this.apiUrl}/api/pronostico/imagenes/hidrometeorologico?${this.hash}${this.webp}`)
      return { type: 'PRONOSTICO_METEOROLOGICO_FETCHED', payload: response }
    } catch (e) {
      return { type: 'PRONOSTICO_METEOROLOGICO_ERROR', payload: e }
    }
  }
}
